import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { FolderPermissionActionType, IrisDmsFolderPermissionI } from '@iris/common/modules/dms/models/IrisDMSFolderPermission';
import { Observable, of } from 'rxjs';
import { IrisPermissionI } from '@iris/common/models/IrisPermission';
import { ApiUrl, IrisApiClient } from '@iris/api-query';
import { catchError } from 'rxjs/operators';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';

@Injectable({
  providedIn: 'root',
})
@ApiUrl('/dms2/{iris@instanceId}/security/folders')
export class IrisFolderPermissionsService extends IrisApiClient<IrisDmsFolderPermissionI> {
  protected readonly http: HttpClient;
  private readonly toastService = inject(ToastService);

  constructor() {
    const http = inject(HttpClient);

    super(http);
  
    this.http = http;
  }

  @ApiUrl('~/{folderId}/permissions')
  getPermissions(folderId: string): Observable<IrisDmsFolderPermissionI[]> {
    return this.http.get<IrisDmsFolderPermissionI[]>(this.url({ folderId }));
  }

  @ApiUrl('~/{folderId}/user-groups/{userGroupId}/permission?inherit-to-subfolders=false')
  setPermission(
    folderId: string,
    userGroupId: number,
    action: FolderPermissionActionType,
    allowed: boolean,
  ): Observable<IrisPermissionI> {
    return this.http.post<IrisPermissionI>(this.url({ folderId, userGroupId }), { action, allowed });
  }

  @ApiUrl('/dms2/{iris@instanceId}/security/permissions/{permissionId}?inherit-to-subfolders=false')
  removePermission(permissionId: number): Observable<IrisPermissionI> {
    return this.http.delete<IrisPermissionI>(this.url({ permissionId }));
  }

  @ApiUrl('~/{folderId}/user-groups/{userGroupId}/permission/{permissionId}')
  deletePermission(
    folderId: string,
    userGroupId: number,
    permissionId: number,
  ): Observable<IrisPermissionI> {
    return this.http.delete<IrisPermissionI>(this.url({ folderId, userGroupId, permissionId }));
  }

  @ApiUrl('~/{folderId}/actions')
  getPermissionActions(folderId: string): Observable<FolderPermissionActionType[]> {
    return this.http.get<FolderPermissionActionType[]>(this.url({ folderId })).pipe(
      catchError(err => {
        if (err.status === HttpStatusCode.NotFound) {
          this.toastService.error({ message: 'Not found' });
        }
        return of(null);
      }),
    );
  }
}
